import { Injectable } from '@angular/core';
import { PagingModel } from '../../@AppService/Models/PagingModel';
import { BaseService } from './BaseService';
import { QueryModel } from '../../@AppService/Models/queryModel';

@Injectable({
    providedIn: 'root',
})
export class PagingService {
    Get(service: BaseService, query: QueryModel) {
        return service.get(query);
    }

    setPage(page: number, component: PagingModel, service: BaseService, url: string = '') {

        if (page < 1 || page === component.currentPage || page > component.totalPages) {
            return;
        }
        component.query.currentPage = page;
        component.currentPage = page;
        service.getAll(component.query, url).subscribe(data => {
            component.responseObj = data.result;
            component.responseData = data;
            component.totalPages = data.totalPages;
            component.pager = Array.from({ length: data.totalPages }, (v, k) => k + 1);
        });
    }

    setSort(sortBy: string, component: PagingModel, service: BaseService) {
        component.query.sortDirection = component.sortDirection;
        component.query.sort = sortBy;
        service.get(component.query).subscribe(data => {
            component.responseObj = data.result;
            component.responseData = data;
            component.totalPages = data.totalPages;
            component.pager = Array.from({ length: data.totalPages }, (v, k) => k + 1);
        });
    }
}
